module.exports = __webpack_public_path__ + "static/media/CORBADUL_MENU_RESPONSIVE.8325428c.jpg";